//**************************************************************************************************
//*************************************** GridsterService ****************************
//**************************************************************************************************

'use strict';

class GridsterService{

  constructor($http,$q,$rootScope,MessagingService,dragulaService)
  {
    this.$http =$http;
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.MessagingService = MessagingService;
    this.dragulaService = dragulaService; 
    
    this.showFooter=false;
    this.formLocked=false;
    this.formViewType=2;
    this.selectedField={};
    this.selectedFieldParent={};
    this.propertiesOpened=false;
    this.btnSelectedField=null;
    this.confirmDeleteElement=false;
    this.navbarHeight=0;
    this.toolboxItems=[];
    this.taskToolboxItems=[];
    this.dragulaContainers={};
    this.taskToolboxLoaded=false;
    this.showOverlay = false;
    this.dragulaSetupCompleted={};
    this.formViewTypeCounterTask = 0;
    this.formViewTypeCounterDs = 0;
    this.taskOpenedInNewPage=false;
    this.openTaskType="current";
    this.taskDataInNewPage = {'localVars':null,'taskDefinition':null};
    this.pageToolboxItems=[
                                 {id:1,Label:'Start task widget',Type:'init',ElementType:'init',Facss:'fa fa-rocket',PresentationId:null,Locked:false,PresentationLangId:null,ItemId: null,wItemValue: null,TabIndex:100,col: 0,row: 0,SizeY: 5,SizeX: 12, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Name: 'Start task',CodeId: 0,populateType: null,Status:'Active',parentElementId: null,ErrorMsg:'Enter ',Dbtype:"none"},
                                 //{id:2,Label:'Execute task widget',Type:'exe',Facss:'fa fa-cog',PresentationId:null,PresentationLangId:null,Locked:false,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SizeX: 6,SearchText:"Enter...", Name: 'Widget',CodeId: 0,populateType: null,parentElementId: null,ErrorMsg:'Enter error message',Dbtype:"none",TabIndex:100},
                                 {id:2,Label:'Execute task widget',Type:'tlist',ElementType:'tlist',Facss:'fa fa-cog',PresentationId:null,PresentationLangId:null,Locked:false,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SizeX: 6,SearchText:"Enter...", Name: 'Widget',CodeId: 0,populateType: null,parentElementId: null,ErrorMsg:'Enter error message',Status:'Active',Dbtype:"none",TabIndex:100},
                                 {id:3,Label:'Header',Type:'header',ElementType:'header',Facss:'fa fa-header',PresentationId:null, PresentationLangId:null,FormType:'',ShowField:true,  UseDefault:false, ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Dbtype:"none",Name: 'Header ',CodeId: 0,Status:'Active',ErrorMsg:'Enter'},
                                  
                                 ];
    this.column = {id:null,Order:2,DirectiveName:'ktGridColumn',AngularDirectiveName:'kt-grid-column',HideFromToolbox:true,Label:'Widget',Type:'gcol',ElementType:'gcol',Facss:'fa fa-columns',PresentationId:null,PresentationLangId:null,Locked:false,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SizeX: 24,SearchText:"Enter...", Name: 'Layout column',CodeId: 0,PopulateType: null,ParentElementId: null,ErrorMsg:'Enter error message',Dbtype:"none",TabIndex:100,ShowField:true,Status:'Active',layout:[]};
 
    this.row =  {id:null,Order:1,DirectiveName:'ktGridRow',AngularDirectiveName:'kt-grid-row',Label:'Layout container',Type:'row',ElementType:'row',Facss:'fa fa-th-large',PresentationId:null,Locked:false,PresentationLangId:null,ItemId: null,wItemValue: null,TabIndex:100,Col: 0,Row: 0,SizeY: 24,SizeX: 24, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Name: 'Layout container',CodeId: 0,PopulateType: null,ParentElementId: null,ShowField:true,ErrorMsg:'Enter error message',Status:'Active',Dbtype:"none",layout:this.getEmptyColumn()};
                    //{id:1,order:1,DirectiveName:'ktGridRow',placeholder:'Grid row',type:'row',ElementType:'row',Facss:'fa fa-bars',PresentationId:null,Locked:false,PresentationLangId:null,ItemId: null,wItemValue: null,TabIndex:100,col: 0,row: 0,SizeY: 5,SizeX: 24, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", name: 'Layout container',CodeId: 0,populateType: null,parentElementId: null,ShowField:true,ErrorMsg:'Enter error message',Dbtype:"none",layout:[]},
                  
  
    this.menu_item_initial = {id:null,Order:0,DirectiveName:'ktMenuItemDropDown',AngularDirectiveName:'kt-menu-item-dropdown',HideFromToolbox:true,Label:'Navbar dropdown',Type:'navbardd',ElementType:'navbardd',Facss:'fa fa-columns',PresentationId:null,PresentationLangId:null,Locked:false,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SizeX: 24,SearchText:"Enter...", Name: 'Navbar dropdown',CodeId: 0,PopulateType: 'navbarright',ParentElementId: null,ErrorMsg:'Enter error message',Dbtype:"none",Params:{Icon:'fa fa-cog'},TabIndex:100,ShowField:true,Status:'Active',layout:[]};
   
   
    this.toolboxTemplate =[//{id:null,order:1,DirectiveName:'ktGridRow',placeholder:'Layout container',Type:'row',ElementType:'row',Facss:'fa fa-th-large',PresentationId:null,Locked:false,PresentationLangId:null,ItemId: null,wItemValue: null,TabIndex:100,col: 0,row: 0,SizeY: 5,SizeX: 12, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", name: 'Layout container',CodeId: 0,populateType: null,parentElementId: null,ErrorMsg:'Enter error message',Dbtype:"none",layout:this.getEmptyColumn()},
                            this.row,
                            this.column,
                             //     {id:2,placeholder:'Widget',Type:'gcol',Facss:'fa fa-columns',PresentationId:null,PresentationLangId:null,Locked:false,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SizeX: 6,SearchText:"Enter...", Name: 'Widget',CodeId: 0,populateType: null,parentElementId: null,ErrorMsg:'Enter error message',Dbtype:"none",TabIndex:100,layout:[]},
                          {id:null,Order:3,DirectiveName:'ktResourceid',AngularDirectiveName:'kt-resourceid',ElementGroup:'dataset',HideFromToolbox:true,Name:'ResourceId',Type:'resourceid',ElementType:'resourceid',Facss:'fa fa-id-card-o',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true,   UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: false,Related: null,SearchText:"Enter...", Label: 'Dataset id ',ErrorMsg:'Dataset Id is required',LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},MaxLength:0,CodeId: 0,Status:'Active', Dbtype : 'id'},
                          {id:null,Order:4,DirectiveName:'ktLabel',AngularDirectiveName:'kt-label',ElementGroup:'dataset',Name:'Label',Type:'label',ElementType:'label',Facss:'fa fa-font',PresentationId:null,PresentationLangId:null,FormType:'', ShowField:true,  UseDefault:false,ItemId: null,sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Label',LabelLength:24,Parameters:{ElementWidth:24},CodeId: 0,ErrorMsg:'Enter label',Status:'Active'},
                                  {id:null,Order:5,DirectiveName:'ktSeparator',AngularDirectiveName:'kt-separator',ElementGroup:'dataset',Name:'Separator',Type:'hr',ElementType:'hr',Facss:'fa fa-font',PresentationId:null, PresentationLangId:null,FormType:'',ShowField:true,  UseDefault:false, ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", LabelLength:24,Parameters:{ElementWidth:24},Label: 'Separator ',CodeId: 0,ErrorMsg:'Enter error message',Status:'Active'},
                                  {id:null,Order:6,DirectiveName:'ktHeader',AngularDirectiveName:'kt-header',ElementGroup:'dataset',Name:'Header',Type:'header',ElementType:'header',Facss:'fas fa-heading',PresentationId:null, PresentationLangId:null,FormType:'',ShowField:true,  UseDefault:false, ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Header',CodeId: 0,ErrorMsg:'Enter error message',Status:'Active'},
                                 // {id:null,Order:6,DirectiveName:'ktTextbox',Name:'Text',Type:'textbox',ElementType:'textbox',Facss:'fa fa-font',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true,   UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Label ',ErrorMsg:'Enter error message ',MaxLength:255,multiline:false,CodeId: 0,LabelLength:5,ValueLength:5, Dbtype : 'charfielddefinition'},
                                  {id:null,Order:8,DirectiveName:'ktRichtextbox',AngularDirectiveName:'kt-richtextbox',ElementGroup:'dataset',Name:'RichTextbox',Type:'richtextbox',ElementType:'rtb',Facss:'fa fa-font',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true,   UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Rich textbox',ErrorMsg:'Enter error message',MaxLength:255,multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active', Dbtype : 'textfielddefinition'},
                                  {id:null,Order:9,DirectiveName:'ktNumber',AngularDirectiveName:'kt-number',ElementGroup:'dataset',Name:'Number',Type:'number',ElementType:'number',Facss:'fa fa-calculator',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true,  UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...",Label: 'Number',ErrorMsg:'Enter error message',CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active',Dbtype : 'integerfielddefinition'},
                                  {id:null,Order:10,DirectiveName:'ktList',AngularDirectiveName:'kt-list',ElementGroup:'dataset',Name:'List',Type:'list',ElementType:'list',Facss:'fa fa-list-alt',PresentationId:null, PresentationLangId:null,FormType:'',ShowField:true,  UseDefault:false, ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"search...", Label: 'List',ErrorMsg:'Enter error message', LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},CodeId: 12,Status:'Active', Dbtype : 'foreignkeydefinition'},
                                  //{id:null,Order:10,DirectiveName:'ktDate',Name:'Date',Type:'date',ElementType:'date',Facss:'fa fa-calendar',PresentationId:null, PresentationLangId:null,FormType:'', ShowField:true,  UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,Label: 'Date ',ErrorMsg:'Enter date', CodeId: 0,LabelLength:5,ValueLength:5,Dbtype : 'datetimefielddefinition'},
                                  {id:null,Order:12,DirectiveName:'ktTime',AngularDirectiveName:'kt-time',ElementGroup:'dataset',Name:'Time',Type:'time',ElementType:'time',Facss:'fa fa-clock',PresentationId:null, PresentationLangId:null,FormType:'', ShowField:true,  UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,Label: 'Time',ErrorMsg:'Enter time', CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active',Dbtype : 'datetimefielddefinition'},
                                  {id:null,Order:13,DirectiveName:'ktResource',AngularDirectiveName:'kt-resource',ElementGroup:'dataset',Name:'Dataset',Type:'resource',ElementType:'resource',Facss:'fa fa-database',PresentationId:null,PresentationLangId:null, FormType:'',ShowField:true,  UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Dataset',ErrorMsg:'Dataset ',CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active', Dbtype : 'manytomanyfielddefinition'},
                                  {id:null,Order:14,DirectiveName:'ktResourceLink',AngularDirectiveName:'kt-resourcelink',ElementGroup:'dataset',Name:'Dataset link',Type:'resourcelink',ElementType:'resourcelink',Facss:'fa fa-database',PresentationId:null,PresentationLangId:null, FormType:'',ShowField:true,  UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Dataset link',ErrorMsg:'Dataset ',CodeId: 0,LabelLength:24,Parameters:{ElementWidth:24},Status:'Active',ValueLength:24, Dbtype : 'gdatesetdefinitionfield'},
                                  {id:null,Order:15,DirectiveName:'ktTabs',AngularDirectiveName:'kt-tabs',ElementGroup:'dataset',Name:'Tabs',Type:'tabs',Facss:'fa fa-globe',ElementType:'tabs',PresentationId:null,PresentationLangId:null,FormType:'',ShowField:true , UseDefault:false,Label:'Tabs'},
                                  {id:null,Order:16,DirectiveName:'ktUser',AngularDirectiveName:'kt-user',ElementGroup:'dataset',Name:'User',Type: 'user',Facss:'fa fa-user',ElementType:'user',PresentationId:null, PresentationLangId:null,MetaData: null,FormType:'',ShowField:true,  UseDefault:false, ItemId: null,sItemValue: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'User',CodeId: 0, ErrorMsg:'Enter error message',LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active', Dbtype : 'foreignkeydefinition'},
                                  {id:null,Order:17,DirectiveName:'ktGroup',AngularDirectiveName:'kt-group',ElementGroup:'dataset',Name:'Group',Type: 'group',Facss:'fa fa-users',ElementType:'group',PresentationId:null, PresentationLangId:null, MetaData: null,FormType:'', ShowField:true,  UseDefault:false,ItemId: null,sItemValue: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Group',CodeId: 0, ErrorMsg:'Enter error message',LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active', Dbtype : 'foreignkeydefinition'},
                                  {id:null,Order:18,DirectiveName:'ktCalculatedField',AngularDirectiveName:'kt-calcfield',ElementGroup:'dataset',Name:'Calculated_field',Type: 'calcfield',ElementType:'calcfield',Facss:'fa fa-calculator',PresentationId:null, PresentationLangId:null, MetaData: null,FormType:'', ShowField:true,  UseDefault:false,ItemId: null,sItemValue: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Calculated field',CodeId: 0, ErrorMsg:'Enter text ',LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active'} ]; 
  
    
    this.taskToolboxTemplate=[
                               //   {id:1,Label:'Grid row',Type:'grow',Facss:'fa fa-bars',PresentationId:null,PresentationLangId:null,ItemId: null,wItemValue: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Name: 'grow',CodeId: 0,populateType: null,parentElementId: null,ErrorMsg:'Enter error message',dbType:"none"},
                                 // {id:2,Label:'Widget',Type:'gcol',Facss:'fa fa-columns',PresentationId:null,PresentationLangId:null,Locked:false,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SizeX: 6,SearchText:"Enter...", Name: 'Widget',CodeId: 0,populateType: null,parentElementId: null,ErrorMsg:'Enter error message',dbType:"none",TabIndex:100,layout:[]},
                                  this.row,
                                  {id:null,Order:2,DirectiveName:'ktHeader',AngularDirectiveName:'kt-header',ElementGroup:'task',Label:'Header',Type:'header',ElementType:'header',Facss:'fas fa-heading',PresentationId:null, PresentationLangId:null,FormType:'',ShowField:true,  UseDefault:false, ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Dbtype:"none",Name: 'Header ',CodeId: 0,ErrorMsg:'Enter error message',Status:'Active'},
                                  {id:null,Order:3,DirectiveName:'ktTaskDatasetList',AngularDirectiveName:'kt-task-dataset-list',ElementGroup:'task',Label:'Dataset list',Type:'rlist',ElementType:'rlist',Facss:'fa fa-list',PresentationId:null,PresentationLangId:null,ItemId: null,wItemValue: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Name: 'list',CodeId: 0,populateType: null,parentElementId: null,ErrorMsg:'Enter error message',Status:'Active',Dbtype:"none"},
                                  {id:null,Order:4,DirectiveName:'ktTaskAddResource',AngularDirectiveName:'kt-task-add-resource',ElementGroup:'task',Label:'Add dataset record',Type:'add',ElementType:'add',Facss:'fa fa-plus',PresentationId:null,PresentationLangId:null,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Name: 'add',CodeId: 0,populateType: null,parentElementId: null,ErrorMsg:'Enter error message',Status:'Active',Dbtype:"none"},
                                  {id:null,Order:5,DirectiveName:'ktTaskAddMultipleResource',AngularDirectiveName:'kt-task-add-multiple-resource',ElementGroup:'task',Label:'Add multiple dataset records',Type:'madd',ElementType:'madd',Facss:'fa fa-plus',PresentationId:null,PresentationLangId:null,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Name: 'madd',populateType: null,parentElementId: null,ErrorMsg:'Enter error message',CodeId: 0,Status:'Active', Dbtype : 'none'},
                                 
                                  {id:null,Order:6,DirectiveName:'ktTaskUpdateResource',AngularDirectiveName:'kt-task-update-resource',ElementGroup:'task',Label:'Update dataset record',Type:'update',ElementType:'update',Facss:'fa fa-globe',PresentationId:null,PresentationLangId:null,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Name: 'update',populateType: null,parentElementId: null,ErrorMsg:'Enter error message',CodeId: 0,Status:'Active', Dbtype : 'none'},
                                  {id:null,Order:7,DirectiveName:'ktTaskUpdateMultipleResource',AngularDirectiveName:'kt-task-update-multiple-resource',ElementGroup:'task',Label:'Update multiple dataset records',Type:'mupdate',ElementType:'mupdate',Facss:'fa fa-globe',PresentationId:null,PresentationLangId:null,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Name: 'mupdate',populateType: null,parentElementId: null,ErrorMsg:'Enter error message',CodeId: 0,Status:'Active', Dbtype : 'none'},
                                  {id:null,Order:8,DirectiveName:'ktTaskViewResource',AngularDirectiveName:'kt-task-view-resource',ElementGroup:'task',Label:'View dataset record',Type:'view',ElementType:'view',Facss:'fa fa-eye',PresentationId:null,PresentationLangId:null,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...",Name: 'view',populateType: null,parentElementId: null,ErrorMsg:'Enter error message',CodeId: 0,Status:'Active',Dbtype : 'none'},
                                //{id:7,Label:'Search resource widget',Type:'search',Facss:'fa fa-search',PresentationId:null,PresentationLangId:null,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...",Name: 'search',populateType: null,parentElementId: null,ErrorMsg:'Enter error message',CodeId: 0,Dbtype : 'none'},
                                  {id:null,Order:9,DirectiveName:'ktUserWidget',AngularDirectiveName:'kt-user-widget',ElementGroup:'task',Label:'User widget',Type:'user',ElementType:'user',Facss:'fa fa-user',PresentationId:null,PresentationLangId:null,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Search or select user...",Name: 'user',populateType: null,parentElementId: null,ErrorMsg:'Select user',CodeId: 0,Status:'Active',Dbtype : 'none'},
                                  {id:null,Order:10,DirectiveName:'ktTaskFiles',AngularDirectiveName:'kt-task-files',ElementGroup:'task',Label:'Files list',Type:'files',ElementType:'files',Facss:'fa fa-file-alt',PresentationId:null,PresentationLangId:null,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Select files...",Name: 'files',populateType: null,parentElementId: null,ErrorMsg:'Files error',CodeId: 0,Status:'Active',Dbtype : 'none'},
                                  {id:null,Order:11,DirectiveName:'ktUploader',AngularDirectiveName:'kt-uploader',ElementGroup:'task',Label: 'File upload',Name:'File',Type: 'uploader',ElementType:'uploader',Facss:'fa fa-upload',PresentationId:null, PresentationLangId:null, MetaData: null,FormType:'', ItemId: null,sItemValue: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", CodeId: 0, ErrorMsg:'Select file',Status:'Active', Dbtype : 'none'},
                                  {id:null,Order:12,DirectiveName:'ktInitiateTaskWidget',AngularDirectiveName:'kt-initiate-task-widget',ElementGroup:'task',Label: 'Initiate task widget',Name:'itask',Type: 'itask',ElementType:'itask',Facss:'fa fa-rocket',PresentationId:null, PresentationLangId:null, MetaData: null,FormType:'', ItemId: null,sItemValue: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", CodeId: 0,Status:'Active', ErrorMsg:'Odaberite task', Dbtype : 'none'},
                                  {id:null,Order:14,DirectiveName:'ktSendNotificationWidget',AngularDirectiveName:'kt-send-notification-widget',ElementGroup:'task',Label: 'Send notification widget',Name:'sendn',Type: 'sendn',ElementType:'sendn',Facss:'fa fa-envelope',PresentationId:null, PresentationLangId:null, MetaData: null,FormType:'', ItemId: null,sItemValue: null, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", CodeId: 0, ErrorMsg:'Odaberite task',Status:'Active', Dbtype : 'none'},
                                  {id:null,Order:15,DirectiveName:'ktChartWidget',AngularDirectiveName:'kt-chart-widget',ElementGroup:'task',Label:'Chart widget',Type:'chart',ElementType:'chart',Facss:'fas fa-chart-bar',PresentationId:null,Locked:false,PresentationLangId:null,ItemId: null,wItemValue: null,TabIndex:100,col: 0,row: 0,SizeY: 5,SizeX: 12, ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Name: '',CodeId: 0,populateType: null,parentElementId: null,Status:'Active',ErrorMsg:'Enter test ',Dbtype:"none"},
                                  {id:null,Order:16,DirectiveName:'ktTaskListWidget',AngularDirectiveName:'kt-task-list-widget',ElementGroup:'task',Label:'Execute task widget',Type:'tlist',ElementType:'tlist',Facss:'fa fa-cog',PresentationId:null,PresentationLangId:null,Locked:false,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SizeX: 6,SearchText:"Enter...", Name: 'Widget',CodeId: 0,populateType: null,parentElementId: null,ErrorMsg:'Enter error message',Status:'Active',Dbtype:"none",TabIndex:100},
                                 
                                  //{id:null,Order:16,DirectiveName:'ktExecuteTaskWidget',AngularDirectiveName:'kt-execute-task-widget',ElementGroup:'task',Label:'Execute task widget',Type:'tlist',ElementType:'tlist',Facss:'fa fa-cog',PresentationId:null,PresentationLangId:null,Locked:false,ItemId: null, ItemValue: null,Saved: false,Required: true,Related: null,SizeX: 6,SearchText:"Enter...", Name: 'Widget',CodeId: 0,populateType: null,parentElementId: null,ErrorMsg:'Enter error message',Status:'Active',Dbtype:"none",TabIndex:100},
                                 
                                  ];  
  
  
    
  }
  static $inject = ['$http','$q','$rootScope','MessagingService','dragulaService'];

 
   
   showHideFooter (val)
   {
      this.showFooter = val;
   };
 
   setOverlay (val)
   {
      this.showOverlay = val;
   };
   
     getOverlay ()
   {
    return this.showOverlay;
   };
   setNavbarHeight (val)
   {
    this.navbarHeight=val;  
   };
   getPaddingForBody ()
   {
    return {'padding-top':(this.navbarHeight-8)+'px'}; 
   };
    getTopForSticky (offset,important)
    
   {
    var style = (this.navbarHeight+offset)+'px';
    if (important) style = style + ' !important';
    return {'top':style};
  
   };
    calcTopForExtendedProperties(element)
    {
      
      var offsetTop = element.offsetTop;
      
      return {'top':(offsetTop)+'px'}; 
      
    };
  
    
   
  getEmptyColumn (){
      
     var emptyColumn = [angular.copy(this.column)];
     emptyColumn[0].id=1;
     return emptyColumn;
  };
  
   
    getOpenTaskInNewPage ()
   {
     return this.taskOpenedInNewPage; 
   };
    setOpenTaskInNewPage (taskOpened)
   {
    this.taskOpenedInNewPage=taskOpened;
    if (!taskOpened) this.openTaskType="";
   };
   
    getOpenTaskType ()
   {
     return this.openTaskType; 
   };
    setOpenTaskType (openTaskType)
   {
    this.openTaskType=openTaskType;  
   };
   getTaskDataInNewPage (){

    return this.taskDataInNewPage;  
   };
   setTaskDataInNewPage (taskDataOpened){

    this.taskDataInNewPage=taskDataOpened;  
   };
   getToolboxTtems ()
   {
    return this.toolboxItems;  
   };
    getTaskToolboxTtems ()
   {
    return this.taskToolboxItems;  
   };
   
   getToolboxTemplate ()
   {
    return this.toolboxTemplate;  
   };
    getTaskToolboxTemplate ()
   {
    return this.taskToolboxTemplate;  
   };
                   
  RegisterDatasetWidget  (widget)
  {
    var pos = this.toolboxItems.map(function(e) { return e.ElementType; }).indexOf(widget.ElementType);
    var insert = false;
    if (pos<0)
    {
      widget.id=this.toolboxItems.length+1;
      
      for (var j=0;j<this.toolboxItems.length;j++)
      {
      if (widget.Order<this.toolboxItems[j].Order)
      {
        this.toolboxItems.splice(j,0,widget);
        insert = true;
        break;
        }
      }
      if (!insert) this.toolboxItems.push(widget);
    }
    else
    {
      this.MessagingService.addMessage('Duplicate registration error for dataset widget '+widget.ElementType+' in directive - '+widget.DirectiveName,'error');
    }
    
     
  };
  
    RegisterTaskWidget  (widget)
  {
    var pos = this.taskToolboxItems.map(function(e) { return e.ElementType; }).indexOf(widget.ElementType);
    var insert = false;
    if (pos<0)
    {
      widget.id=this.taskToolboxItems.length+1;
       for (var j=0;j<this.taskToolboxItems.length;j++)
      {
      if (widget.Order<this.taskToolboxItems[j].Order)
      {
        this.taskToolboxItems.splice(j,0,widget);
        insert = true;
        break;
        }
      }
      if (!insert) this.taskToolboxItems.push(widget);
    }
    else
    {
      this.MessagingService.addMessage('Duplicate registration error for task widget '+widget.ElementType+' in directive - '+widget.DirectiveName,'error');
    }
    
  };
  
    GetElementPropertiesTemplate  (ElementType)
  {
     var pos = this.toolboxItems.map(function(e) { return e.ElementType; }).indexOf(ElementType);
     if (pos<0)
    {
       this.MessagingService.addMessage('Element properties error - '+ElementType+' not found!','error');
       return '';
    }else{
      
      return this.toolboxItems[pos].DirectiveName;
    }
  };
  
  
  getFormLockStatus (){
      return this.formLocked;
  }
   setFormLockStatus (iFormLockStatus){
      this.formLocked=iFormLockStatus;
  }
  
  getEmptyRow (){
      
     var emptyRow =  [
					this.getToolboxItemsById(0)];
     return emptyRow;
  }

getEmptyRowWithId (formLayout){
      
     var emptyRow = angular.copy(this.row);
         emptyRow.id = this.getNewElementId(formLayout)+1;
         emptyRow.layout =  [angular.copy(this.getEmptyColumnWithId(formLayout))];
     return emptyRow;
  }
 
  
  getEmptyColumnWithId (formLayout){
      
     var emptyColumn = angular.copy(this.column)
         emptyColumn.id = this.getNewElementId(formLayout)+1;
     return emptyColumn;
  }
 
  
  getEmptyDatasetForm (){
     
     var row =  angular.copy(this.row);
     row.id=1;
     var emptyDatasetForm = [row];
         emptyDatasetForm[0].layout =  angular.copy(this.getColumnWithDatasetId());
     return emptyDatasetForm;
  }
  
  getEmptyTaskForm (){
      
     var emptyDatasetForm = [angular.copy(this.row)];
     emptyDatasetForm[0].id=1;
     emptyDatasetForm[0].layout =  angular.copy(this.getEmptyColumn());
     return emptyDatasetForm;
  }
  
   getEmptyApplicationMenu (){
     
     var row =  angular.copy(this.row);
     row.id=1;
     var emptyApplicationMenu = [row];
         emptyApplicationMenu[0].layout =  [angular.copy(this.getColumnWithInitialMenu())];
     return emptyApplicationMenu;
  }                               

  getColumnWithDatasetId (){
      
     var column = angular.copy(this.getEmptyColumn());
     var resource_id = angular.copy(this.toolboxTemplate[2]);
     resource_id.id=column[0].layout.length+1;
     column[0].layout = [resource_id];
     return column;
  }
  
    getColumnWithInitialMenu (){
      
     //var column = angular.copy(this.getEmptyColumn());
     let menu_item = angular.copy(this.menu_item_initial);
     //menu_item.id=column[0].layout.length+1;
     menu_item.id=1;
     //column[0].layout = [menu_item];
     return menu_item;
  }

   getNewElementId (formLayout){
    
      var tmp_max=0,max=0;
      for (var i=0;i< formLayout.length;i++)
      {
        if ("layout" in formLayout[i])
        {
          if (formLayout[i].layout.length>0){
          
            tmp_max = this.getNewElementId(formLayout[i].layout);
          }
        }
        if ("id" in formLayout[i])
        {
            if(formLayout[i].id>tmp_max)
            {
              tmp_max = formLayout[i].id;  
            }            
        }
        if (tmp_max>max)
        {
          max=tmp_max;
          
        }
       
      }
      
      //max++;
      
      return max;
  }
 ProcessWidgets (widgets){
      
     var lWidgets = [];
     for (var i=0;i<widgets.length;i++){
      if (widgets[i].ShowField) {
        lWidgets.push(widgets[i]);
      }
     }
     return lWidgets;
  }
 
  
  getToolboxItems (){
  
       
    return this.toolboxItems;
  }
  
  getTaskToolboxItems (){
  
       
    return this.taskToolboxItems;
  }
    getPageToolboxItems (){
  
       
    return this.pageToolboxItems;
  }
    
  getTaskToolboxItemsById (id){
  
       
    return this.taskToolboxItems[id];
  }
  
  getToolboxItemsById (id){
  
       
    return this.toolboxItems[id];
  }
  
  getTaskToolboxItems (){
               
   
    return this.taskToolboxItems;
  }
 
 
getFieldPropertiesOpened (){
  
       
    return this.propertiesOpened;
  }
setFieldPropertiesOpened (value){
  
       
   this.propertiesOpened=value;
   
  } 
 getFieldProperties  (){
  
       
    return this.selectedField;
  }

   getFieldParent  (){
  
       
    return this.selectedFieldParent;
  }
  
   getSelectedItemId  (){
  
       
    return this.selectedField.ItemId;
  }
  
   getSelectedFd  (){
  
       
    return this.selectedField;
  }
  
 setFieldProperties (field,parent){
  
       
    this.propertiesOpened=true;
    this.selectedField=field;
    this.selectedFieldParent = parent;
    
  }
 
 getFormViewType  (){
  
       
    return this.formViewType;
  }

   setFormViewType  (formViewType){
  
       
    this.formViewType=formViewType;
    if (formViewType == 4)
    {
      this.formViewTypeCounterTask=0;
      this.formViewTypeCounterDs=0;
    }
  };
  
  addFormViewTypeCounterTask  (val){
      this.formViewTypeCounterTask+=val;
  };

  
  addFormViewTypeCounterDs  (val){
      this.formViewTypeCounterDs+=val;
  };  

 changeConfirmDeleteElement (){
  
       
    this.confirmDeleteElement=!this.confirmDeleteElement;
 };
 
 getConfirmDeleteElement (){
  
       
    return this.confirmDeleteElement;
 };

 setConfirmDeleteElement (value){
  
       
    this.confirmDeleteElement=value;
 };
 
 deleteElement  (item){
                      
                      if ('layout' in item)
                      {
                          if (item.layout.length==0)
                          {
                            
                              //this.selectedFieldParent.layout.splice( this.selectedFieldParent.layout.indexOf(item), 1);
                              this.selectedField.Status="Deleted";
                              this.selectedField={};
                              this.propertiesOpened = false;
                              this.confirmDeleteElement=false;
                              this.selectedFieldParent.countActive--;
                              
                          }else if (item.layout.length==1)
                          {
                            if ('layout' in item.layout[0])
                              {
                                 if (item.layout[0].layout.length==0)
                                 {
                                   //this.selectedFieldParent.layout.splice( this.selectedFieldParent.layout.indexOf(item), 1);
                                   this.selectedField.Status="Deleted";
                                   this.selectedField={};
                                   this.propertiesOpened = false;
                                   this.confirmDeleteElement=false;
                                   this.selectedFieldParent.countActive--;
                                  } else this.MessagingService.addMessage('Delete failed - element not empty!','error');
                            }
                            else{
                              
                               //this.selectedFieldParent.layout.splice( this.selectedFieldParent.layout.indexOf(item), 1);
                               this.selectedField.Status="Deleted";
                               this.selectedField={};
                               this.propertiesOpened = false;
                               this.confirmDeleteElement=false;
                               this.selectedFieldParent.countActive--;
                            }
                          }
                      }else
                          {
                            
                             //this.selectedFieldParent.layout.splice( this.selectedFieldParent.layout.indexOf(item), 1);
                             this.selectedField.Status="Deleted";
                             this.selectedField={};
                             this.propertiesOpened = false;
                             this.confirmDeleteElement=false;
                          }
  };
 
  SetTaskToolboxLoaded (val)
   {
    this.taskToolboxLoaded=val;  
   };
   
     GetTaskToolboxLoaded ()
   {
    return this.taskToolboxLoaded;  
   };
 
 //**********************************************************
 //          Drag And Drop dragular - not used
 //************************************************************
 /*
 this.setupDragular (model,container,namespace,handleClass,revOnSpill)
 
 {
              
                
                                  $timeout(function(){
                                   
                                     dragularService(container,
                                      {
                                      nameSpace: namespace,
                                      //copy: true,
                                      classes: {
                                      //mirror: 'show-border'
                                          },
                                      revertOnSpill: revOnSpill,
                                      containersModel: model,
                                      //direction:'vertical',
                                   
                                        moves: function (el, container, handle) {
                                         
                                          return handle.classList.contains(handleClass);
                                        }
                                 
                                       }
                                       );
                                     }
                                   );
  
  }
*/
 
 //************************************************************
 //        destroy dragula
 //************************************************************
 destroyDragula (dragula_bag)
{
    var bag = this.dragulaService.find(this.$rootScope, dragula_bag);
     if (bag) {
     // var drake = bag.drake;
     // drake.containers.length = 0;
     // drake.models.length = 0;
     this.dragulaService.destroy(this.$rootScope, dragula_bag);         
      }
};
 //************************************************************
 //        initial dragula setup
 //************************************************************
 setupDragula (dragula_bag,source_container,drag_handle)
{
 // if (!this.dragulaSetupCompleted[dragula_bag])
 // {
    //destroy dragula if exists
   
      var bag = this.dragulaService.find(this.$rootScope, dragula_bag);
      if (!bag) {
         //   this.dragulaService.destroy(this.$rootScope, dragula_bag)         
     
      
         this.dragulaService.options(this.$rootScope, dragula_bag, {
                           revertOnSpill: true,
                           removeOnSpill: false,
                           copy:function (el,source){
                            
                             return source.id==source_container;
                            },
                           accept:function (el,target, source) {
                               return target.id!=source_container;
                           },
                           moves: function (el, container, handle) {
                                     return handle.classList.contains(drag_handle);
                           }
         
         });
      }
   //  this.dragulaSetupCompleted[dragula_bag] = true;   
};

 //**********************************************************
 //        register dragula containers
 //************************************************************
 registerDragulaContainer (taskId,formType,bag,container)
{
  var bag = this.dragulaContainers[bag];
  if (bag==undefined)
  {
   
   
  }
  var containers = this.dragulaContainers[bag][taskId+formType];
  //if (containers ==undefined)
};
 
}
export default GridsterService;